import { gql } from '@apollo/client';

export const RESOLVE_DUPLICATE_INSTITUTIONS = gql`
  mutation resolveDuplicateInstitutions($inputs: [ResolveDuplicateInstitutionInput!]!) {
    institutions: resolveDuplicateInstitutions(inputs: $inputs) {
      id
    }
  }
`;
